<input type="text" class="input" [(ngModel)]="SearchTerm" name="SearchTerm" placeholder="Search..." style="border-bottom-left-radius: 10px; border-top-left-radius: 10px;"/>
<span class="icon is-right">
  @if ((SearchTerm != '' ) && AllowSearchClear == true) {
    <a class="fa fa-close fa-lg allow-events"
    (click)="ClearSearch()"></a>
  }
</span>
